/*
=========================================================
* Material Kit 2 PRO React - v2.1.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 PRO React examples

function Information() {
  return (
    <MKBox component="section" py={{ xs: 6, md: 12 }}>
      <Container>
        <Grid container item xs={12} justifyContent="center">
          <Grid item xs={12} md={10} lg={8} textAlign="center">
            <MKTypography variant="body2" p={2}>
              <strong>Willy Woef</strong> is een digitale hondenfluisteraar. Hij is gemaakt om op
              een begrijpelijke manier uit te leggen hoe honden zich gedragen en hoe jij daar als
              baasje het beste mee om kunt gaan. Honden communiceren niet zoals mensen, maar
              gebruiken gedrag en rangorde om duidelijk te maken wie welke rol speelt binnen de
              groep (of hondenroedel).
            </MKTypography>
            <MKTypography variant="body2" p={2}>
              Bijvoorbeeld, als een hond een stok pakt, doet hij dat niet alleen om met jou te
              spelen. Hij pakt de stok omdat hij denkt dat jij hem de stok gaat afpakken. Als jij
              dat doet, laat de hond zien dat jij &apos;hoger&apos; in de rangorde staat. Het is dus
              een manier waarop honden laten zien wie de baas is.
            </MKTypography>
            <MKTypography variant="body2" p={2}>
              Soms zie je een hond een sok, schoen of theedoek pakken. Hij doet dat niet omdat hij
              het leuk vindt, maar omdat hij denkt dat jij het weer van hem afpakt. Dit helpt de
              hond om te begrijpen waar hij in de &apos;roedel&apos; staat. Zo weet de hond hoe hij
              zich moet gedragen om goed samen te leven met de mensen in het huishouden.
            </MKTypography>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
